export const educationType = ["ĐỊNH KỲ", "BAN ĐẦU", "PHỤC HỒI", "BỒI DƯỠNG KT"];

export const educationTypeOptions = educationType.map((e) => ({
  label: e,
  value: e,
}));
